query GetImpactMeasurementCategory($id: ID!) {
  impactMeasurementCategory(id: $id) {
    id
    title
    headingColour
    items {
      id
      title
      description
      example
      impactMeasurementCategoryId
      readMore
    }
  }
}
